$(function() {
  if ('WebkitColumnCount' in document.body.style || 'MozColumnCount' in document.body.style || 'OColumnCount' in document.body.style || 'MsColumnCount' in document.body.style || 'columnCount' in document.body.style) {
    $('ul.dropdown').filter(function() {
      return $(this).find('li').size() > 10
    }).addClass('mega-menu');
  }
});


// Centering dropdown
document.onreadystatechange = function() {
    if (document.readyState === 'complete') {
        $(".site-nav__dropdown").each(function(){
            var parentWidth = $(this).parent().innerWidth();
            var menuWidth = $(this).innerWidth();
            var margin = (parentWidth / 2 ) - (menuWidth / 2);
            margin = margin + "px";
            $(this).css("margin-left", margin);
        });
    }
}